import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { authInterceptorFn, AuthModule } from '@plugins/client/auth';
import { JsonDateModule } from '@plugins/client/json-date';
import { LANGUAGES } from '@plugins/client/routing/app.guard';
import { providePluginsPrimeNG } from '@plugins/client/styles/primeng';
import { localeIdProvider } from '@plugins/client/translate/providers';
import { MiddlewareSdkModule } from '@plugins/middleware-sdk';

import { environment } from '../environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideAnimationsAsync(),
    providePluginsPrimeNG(),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    importProvidersFrom(MiddlewareSdkModule),
    importProvidersFrom(AuthModule.forRoot()),
    importProvidersFrom(JsonDateModule.configure({ paths: ['/api/'] })),
    localeIdProvider(environment.languages),
    { provide: LANGUAGES, useValue: environment.languages },
  ],
};
